import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { toDecimal } from "../unit/public";
import { getAccount, extractLoginData } from "../unit/UserUtil";
export default {
  name: "Login",
  props: ["isHaveKeychain", "isShowModelPowerDown", "ruleForm"],
  emits: ["update:isShowModelPowerDown"],
  data: function data() {
    return {
      isUseSteemKeychain: false,
      acitveKey: "",
      isLogin: false,
      isLoginError: false,
      errorMessage: "",
      rememberMe: false,
      loginResult: null,
      isLogining: false,
      loading: null,
      showLoginModel: false,
      fromUser: ""
    };
  },
  watch: {
    isShowModelPowerDown: function isShowModelPowerDown(newVal) {
      this.showLoginModel = newVal;
    },
    showLoginModel: function showLoginModel(newVal) {
      this.$emit("update:isShowModelPowerDown", newVal);
    }
  },
  methods: {
    comfirmTran: function comfirmTran() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.acitveKey) {
                  _context.next = 4;
                  break;
                }

                _this.errorMessage = "activeKeyError";
                _this.isLoginError = true;
                return _context.abrupt("return");

              case 4:
                _this.isLogining = true;
                _context.prev = 5;
                _context.next = 8;
                return dsteem.powerDown(_this.fromUser, _this.ruleForm.powerDownAmount, _this.acitveKey);

              case 8:
                result = _context.sent;

                if (result) {
                  _this.isLoginError = false;
                  _this.errorMessage = "";
                  _this.isLogining = false;

                  _this.$emit("comfirmPowerDown");
                }

                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);

                if (_context.t0.jse_info.code == 10) {
                  _this.isLoginError = true;
                  _this.errorMessage = "balanceError";
                } else {
                  _this.isLoginError = true;
                  _this.errorMessage = "activeKeyError";
                } //


              case 15:
                /*  if (this.loginResult.code == 0) {
                        this.$emit("comfirmPowerDown");
                } else {
                  this.isLoginError = true;
                  if (this.loginResult.code == -1)
                    this.errorMessage = "userOrPasswordError";
                  else this.errorMessage = "systemError";
                }
                */
                _this.isLogining = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loginData = extractLoginData();

              if (_this2.loginData) {
                _this2.fromUser = _this2.loginData[0];
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};